// TODO: refactor majority of this file and put in common?
import {
  AccountResponseDTO,
  AccountUserDetailDTO,
  canAccessCompany,
  isAccountAdmin,
  isAccountUser,
  isCallCenterUser,
  isSystemUser,
  Permissions,
  PermissionScope,
  RoleEnum,
  UserDetailDTO
} from '_lib/api/apiTypes.shim';

type UserFunctionArgs = {
  user: UserDetailDTO | AccountUserDetailDTO;
};

export const CallTakingEnabledForAccount = (args: UserFunctionArgs & { account?: AccountResponseDTO }) => {
  return !args.user.accountId || (!!args.user.accountId && !!args.account?.isCallTakingEnabled);
};

export const SystemUser = ({ user }: UserFunctionArgs) => isSystemUser(user);

export const CallCenterAdmin = ({ user }: UserFunctionArgs) => isCallCenterUser(user) && user.role === RoleEnum.ADMIN;

export const CallCenterUser = ({ user }: UserFunctionArgs) => isCallCenterUser(user);

export const StandardUser = ({ user }: UserFunctionArgs) =>
  isCallCenterUser(user) || isAccountUser(user) || isSystemUser(user);

export const AccountUser = ({ user }: UserFunctionArgs) => isAccountUser(user);

export const AccountAdmin = ({ user }: UserFunctionArgs) => isAccountAdmin(user);

export const AccountCompanyUser = ({ user }: UserFunctionArgs, companyId: string) =>
  isAccountUser(user) && canAccessCompany(user, companyId);

export const ManageCallCenterUsers = ({ user }: UserFunctionArgs) =>
  user.settings.callPilot.users || Permissions.hasAnyScope(user, [PermissionScope.CALL_CENTER_USER_ADMIN]);

export const ViewCallCenterUsers = ({ user }: UserFunctionArgs) => isCallCenterUser(user) || isSystemUser(user);

export const ManageCompanies = ({ user }: UserFunctionArgs) =>
  user.settings.callPilot.companies ||
  Permissions.hasAnyScope(user, [PermissionScope.COMPANY_ADMIN, PermissionScope.COMPANY_WRITE]);

export const ManageCompanyBilling = ({ user }: UserFunctionArgs) =>
  user.settings.callPilot.companiesBilling ||
  Permissions.hasAnyScope(user, [
    PermissionScope.COMPANY_ADMIN,
    PermissionScope.COMPANY_WRITE,
    PermissionScope.COMPANY_BILLING_ADMIN
  ]);

export const ManageCompanySettings = ({ user }: UserFunctionArgs) =>
  user.settings.callPilot.companiesSettings ||
  Permissions.hasAnyScope(user, [
    PermissionScope.COMPANY_ADMIN,
    PermissionScope.COMPANY_WRITE,
    PermissionScope.COMPANY_SETTINGS_ADMIN
  ]);

// TODO: the `settings.callPilot.companies` permission was re-used for Account, but in future we should start to use
//        the new Account scopes
export const ManageAccounts = ({ user }: UserFunctionArgs) =>
  ManageCompanies({ user }) || Permissions.hasAnyScope(user, [PermissionScope.ACCOUNT_ADMIN]);

export const ManageAccountUsers = ({ user }: UserFunctionArgs) =>
  user.settings.portal.users ||
  Permissions.hasAnyScope(user, [PermissionScope.ACCOUNT_USER_ADMIN]) ||
  ManageCompanies({ user });

export const ManageAppointmentWindows = ({ user }: UserFunctionArgs) =>
  user.settings.portal.appointmentWindows ||
  Permissions.hasAnyScope(user, [PermissionScope.APPOINTMENT_WINDOWS_ADMIN]) ||
  ManageCompanies({ user });

export const ManageCompanyWindows = ({ user }: UserFunctionArgs) =>
  user.settings.portal.companyWindows ||
  Permissions.hasAnyScope(user, [PermissionScope.COMPANY_WINDOWS_ADMIN]) ||
  ManageCompanies({ user });

export const ViewAccounts = ({ user }: UserFunctionArgs) => isCallCenterUser(user) || isSystemUser(user);

export const ViewAccountUsers = ({ user }: UserFunctionArgs) => isAccountUser(user);
